module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAMAAAC/Wk/yAAAAM1BMVEUAmZn///+AzMzA5uYgpqZAs7Pw+fnQ7Oyg2dlgv79QubkQn5+w399wxsYwrKyQ09Pg8/Pr4vitAAAAqUlEQVQoz9XNCw7EIAgEUAb8az/3P+3apVk3aA/QSUyQPDL0tnjuyZVo9540zruJlRPfCJEArEsGW5eBcOTCUSH2B1iAVLVNYXyAJ9r4CFIAL6EH3D/kDcGtIGvVgP3JCh5oBrqAbQEFyUC6ylfVYuFVPsMNqBY6oEzQAWwhMcJhISUg3zc/SBGYYO1Lyd5zlAF3hUY2aNqAxBbqPSdJXPqU2dMt+/SafACMQANeVLLgZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-cn.png
// module id = /59w
// module chunks = 1